export const SERIF_FONT_FAMILY = 'Recoleta, Georgia, Times, serif';
export const SANS_SERIF_FONT_FAMILY =
  '"Basier Square",-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
